const api =
	process.env.NODE_ENV === "production"
		? "https://starewayfilms.com/api"
		: "https://starewayfilms.com/api";

module.exports = {
	api
};



// WEBPACK FOOTER //
// ./src/config.js